import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { peekReturnTo } from '../utils/returnTo';

// Routes where a logged-in user must be redirected away.
// We block render until hydration so they never see the marketing page.
const REDIRECT_ROUTES = ['/', '/login', '/get-started'];

const PublicRedirect = ({ children }) => {
  const location = useLocation();
  const { isAuthenticated, isHydrated, needsProfileSetup } = useSelector(
    (state) => state.auth
  );

  const willRedirect = REDIRECT_ROUTES.includes(location.pathname);

  // Only block render (and wait for auth) on routes that redirect logged-in users.
  // Pages like /faq, /terms, /privacy-policy don't redirect, so render immediately.
  if (!isHydrated && willRedirect) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-white gap-3">
        <img src="/logo.png" alt="MintLink" className="h-12 w-12 animate-pulse" />
        <div className="h-1.5 w-32 bg-gray-100 rounded-full overflow-hidden">
          <div className="h-full bg-gradient-to-r from-[#32764A] to-[#6BB170] animate-[shimmer_1.6s_ease-in-out_infinite] bg-[length:200%_100%]" />
        </div>
      </div>
    );
  }

  if (isHydrated && isAuthenticated && !needsProfileSetup && willRedirect) {
    return <Navigate to={peekReturnTo() || '/dashboard'} replace />;
  }

  return children;
};

export default PublicRedirect;
